import React from "react";


const LoadingDots = ({
    logo = "/assets/img/rmlogo.png",
    message = "Loading...",
    logoSize = 55,
    className = "",
}) => {
    return (
        <div className={`loading-dots-wrapper ${className}`}>
            {logo && (
                <img
                    src={logo}
                    alt="Loading"
                    className="loading-dots-logo"
                    style={{
                        width: `${logoSize}px`,
                        height: `${logoSize}px`,
                    }}
                />
            )}

            <div className="loading-dots">
                <span></span>
                <span></span>
                <span></span>
            </div>

            {message && (
                <p className="loading-dots-message">
                    {message}
                </p>
            )}
        </div>
    );
};

export default LoadingDots;